<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showCreateAsset"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <form
          @submit.prevent="create"
          class="fixed max-h-screen center-h-v bg-white rounded-md shadow-2xl sm:w-2/5 w-full overflow-y-auto"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
          <div
            class="flex justify-between items-center bg-white sticky top-0 border-b-1.5 p-3"
          >
            <p class="text-base">Create Asset</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>
          <transition name="fade">
            <div
              v-if="create_error"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ create_error }}
            </div>
          </transition>
          <transition name="fade">
            <div
              v-if="create_success"
              class="p-1 text-center text-white text-sm w-full bg-green-200"
            >
              {{ create_success }}
            </div>
          </transition>

          <div class="grid grid-cols-1 p-4 gap-5">
            <div class="text-sm">
              <label class="block pb-1">Unique Number</label>
              <input
                v-model="info.AssetNo"
                required
                type="text"
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>
          </div>

          <div class="grid grid-cols-1 p-4 gap-5">
            <div class="text-sm">
              <label class="block pb-1">Serial Number</label>
              <input
                v-model="info.SerialNumber"
                required
                type="text"
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>
          </div>

          <div class="text-sm px-3">
            <label class="block pb-1">Asset Status</label>

            <select
              class="p-2 bg-gray-200 rounded-full w-full"
              v-model="info.StatusName"
            >
              <option
                v-for="(brand, index) in assetStatuses"
                :key="index"
                class="cursor-pointer"
              >
                {{ brand.Name }}
              </option>
            </select>
          </div>
          <br />
          <div class="text-sm px-3">
            <label class="block pb-1">Brand Name</label>

            <el-select
              filterable
              class="bg-gray-200 rounded-full w-full border-none"
              v-model="info.BrandName"
              @change="findModelByBrandName"
              placeholder="Select a branch"
            >
              <el-option
                v-for="brand in brands"
                :key="brand.Id"
                :label="brand.Name"
                :value="brand.Name"
              >
              </el-option>
            </el-select>
          </div>
          <br />
          <div class="text-sm px-3">
            <label class="block pb-1">Model Name</label>

            <el-select
              filterable
              class="bg-gray-200 rounded-full w-full border-none"
              v-model="info.modelName"
              placeholder="Select a branch"
              :disabled="!info.BrandName"
            >
              <el-option
                v-for="model in modelsToSelect"
                :key="model.Id"
                :label="model.Name"
                :value="model.Name"
              >
              </el-option>
            </el-select>
          </div>
          <div class="text-sm px-3">
            <!-- {{ assetTypes }} -->
            <label class="block pb-1">Asset Type</label>

            <select
              class="p-2 bg-gray-200 rounded-full w-full"
              v-model="info.AssetTypeName"
            >
              <option
                v-for="(assetType, index) in assetTypes"
                :key="index"
                class="cursor-pointer"
              >
                {{ assetType.Name }}
              </option>
            </select>
          </div>

          <div class="text-sm px-3">
            <label class="block pb-1">Asset Condition</label>

            <select
              class="p-2 bg-gray-200 rounded-full w-full"
              v-model="info.ConditionName"
            >
              <option
                v-for="(cond, index) in assetCondition"
                :key="index"
                class="cursor-pointer"
              >
                {{ cond.Name }}
              </option>
            </select>
          </div>

          <div class="grid grid-cols-1 p-4 gap-5">
            <div class="text-sm">
              <label class="block pb-1">Description</label>
              <textarea
                v-model="info.Description"
                required
                type="text"
                class="p-2 bg-gray-200 rounded-md w-full"
                rows="4"
                maxlength="500"
                autocorrect="en-US"
              ></textarea>
            </div>
          </div>

          <div class="flex justify-end p-5">
            <button
              type="submit"
              class="bg-primary rounded-full px-10 text-sm text-white py-2"
            >
              Create
            </button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Loader from "@/components/loader/loader.vue";

export default {
  name: "CompanySetupCreateAsset",
  props: ["showCreateAsset", "reload"],
  components: { Loader },
  data() {
    return {
      AssetStatus: "",
      info: {
        AssetNo: "",
        SerialNumber: "",
        AssetTypeId: "",
        AssetStatusId: "",
        Name: "",
        Description: "",
        AssetBrandId: "",
        AssetModelId: "",
        AssetConditionId: "",
        AssetTypeName: "",
      },
      // {
      //   AssetNo: "",
      //   SerialNumber: "",
      //   AssetTypeId: "",
      //   AssetStatusId: "",
      //   Description: "",
      //   AssetBrandId: "",
      //   AssetModelId: "",
      //   AssetConditionId: "",
      // },
      brands: [],
      assetTypes: [],
      assetCondition: [],
      assetStatuses: [],
      models: [],
      create_error: null,
      create_success: null,
      loading: false,
      selectedAssetTypeId: null,
      modelsToSelect: [],
    };
  },

  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
  },
  created() {
    this.getAssetTypes();
    this.getAssetStatuses();
    this.getBrands();
    this.getConditions();
    this.getAssetModel();
  },

  methods: {
    close() {
      this.$emit("close");
    },

    findModelByBrandName(brandName) {
      this.modelsToSelect = this.models.filter(
        (model) => model.Brand === brandName
      );
    },

    // /{organization}/asset/type/v1/request
    getAssetStatuses() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/asset/status/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.assetStatuses = response.data.Data;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
    getConditions() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/asset/condition/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.assetCondition = response.data.Data;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
    getBrands() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/asset/brand/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.brands = response.data.Data;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
    getAssetModel() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/asset/model/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.models = response.data.Data;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
    // /{organization}/asset/v1/create
    create() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };
      console.log(this.info);
      this.info.AssetBrandId = this.brands.find(
        (brand) => brand.Name === this.info.BrandName
      ).Id;
      this.info.AssetStatusId = this.assetStatuses.find(
        (assetStatuses) => assetStatuses.Name === this.info.StatusName
      ).Id;
      console.log(
        this.assetTypes.find(
          (assetType) => assetType.Name === this.info.AssetTypeName
        )
      );
      this.info.AssetTypeId = this.assetTypes.find(
        (assetType) => assetType.Name === this.info.AssetTypeName
      ).Id;
      this.info.AssetConditionId = this.assetCondition.find(
        (condition) => condition.Name === this.info.ConditionName
      ).Id;

      this.info.AssetModelId = this.models.find(
        (models) => models.Name === this.info.modelName
      ).Id;
      axios
        .post(
          `${this.getOrganization}/asset/${this.$ApiVersion}/create`,
          JSON.stringify(this.info),
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.create_success = response.data.StatusMessage;
              this.info = {
                AssetNo: "",
                SerialNumber: "",
                AssetTypeId: "",
                AssetStatusId: "",
                Name: "",
                Description: "",
                AssetBrandId: "",
                AssetModelId: "",
                AssetConditionId: "",
              };
              setTimeout(() => {
                this.create_success = null;
                this.reload();
              }, 2500);
            } else {
              this.create_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.create_error = error.message;
          }
        );
    },

    findAssetTypeByName(selectedAsset) {
      this.info.AssetTypeId = this.assetTypes.find(
        (asset) => asset.Name == selectedAsset
      ).Id;
    },

    findAssetStatusByName(selectedAsset) {
      this.info.AssetStatusId = this.assetStatuses.find(
        (asset) => asset.Name == selectedAsset
      ).Id;
    },

    // /{organization}/asset/type/v1/request
    getAssetTypes() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/asset/type/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.assetTypes = response.data.Data;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
